export const CONFIRMED_GET_SERVICE_CALLER_LIST = "CONFIRMED_GET_SERVICE_CALLER_LIST";
export const CONFIRMED_GET_PATIENTS_LIST = "CONFIRMED_GET_PATIENTS_LIST";
export const CONFIRMED_REASSIGN_PATIENTS = "CONFIRMED_REASSIGN_PATIENTS";